module.exports = __webpack_public_path__ + "static/img/广告片-产品广告片.cd6e432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/广告片-产品广告片.png
// module id = gZSa
// module chunks = 1